<div class="p-4">
  <p class="mb-4 text-lg font-semibold text-blue-dark">
    {{ 'portal.hrisIntegration.dialog.title' | transloco }}
  </p>
  <div
    class="mb-10 rounded-lg border border-orange-light bg-orange-veryLight p-4"
  >
    <div class="flex items-start gap-4">
      <div
        class="flex size-10 items-center justify-center rounded-full bg-orange-100 p-2 text-grey"
      >
        <mat-icon class="material-icons-outlined text-orange">
          info_circle
        </mat-icon>
      </div>
      <p class="text-sm font-semibold text-primary">
        {{ 'portal.hrisIntegration.dialog.banner' | transloco }}
      </p>
    </div>
  </div>
  <unified-directory
    [workspace_id]="workspaceId"
    [environment]="environmentName"
    [dc]="dataRegion"
    [scopes]="permissionScopes"
    [notabs]="true"
    [nostyle]="true"
  />
</div>
